/**
 * Pipe that displays an alert number or outputs a '-' when number is null/undefined
 */
import {Pipe, PipeTransform} from '@angular/core';

import {isPresent} from '../utils/lang';

@Pipe({
  name: 'gpAlertNumber'
})
export class AlertNumberPipe implements PipeTransform {
  public transform(value: number): any {
    if (!isPresent(value) || typeof value !== 'number' || isNaN(value)) {
      return '-';
    }
    return value;
  }
}
